<template>
    <transition name="fade">
        <div class="message" :class="type" v-show="show">
            <i class="icon"></i>
            <span class="text">{{text}}</span>
        </div>
    </transition>
</template>
<script>
export default {
    name: 'message',
    props: {
        type: {
            type: String,
            default: 'info',
            validator: val => ['info', 'success', 'warning', 'error'].includes(val)
            //['info', 'success', 'warning', 'error'] 表示type只接收这四个字符串作为参数传入message组件
        },
        text: {
            type: String,
            default: ''
        },
        show: {
            type: Boolean,
            default: false
        }
    }
}
</script>
<style scoped lang="less">
// fade动画 <transition name="fade"> </transition>
// 下面的样式可以自己改
.fade-enter-active,
.fade-leave-active {
    transition: opacity .3s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.message {
    position: fixed;
    left:0;
    right:0;
    top: 0;
    text-align: center;
    padding: .2rem 0;
    color: #333;
    background: #f5f5f5;
    font-size: .34rem;
    line-height: 1.4;
    z-index: 100000;
    box-shadow: 0 0 10px rgba(0, 0, 0, .3);

    &.info {
        color: #909399;
    }

    &.success {
        color: #67C23A;
    }

    &.error {
        color: #F56C6C;
    }

    &.warning {
        color: #E6A23C;
    }
}
</style>